import React, {Component} from 'react'
import PropTypes from 'prop-types'

class BasketOrderNumber extends Component {
    render() {
        const {orderNumber, orderNumbers = []} = this.props

        return (
            <td className='BasketOrderNumber'>
                {
                    !!orderNumbers.length ? orderNumbers.map(i => `#${i}`).join(", ") :
                    !!orderNumber ? `#${orderNumber}` : '--'
                }
            </td>
        )
    }
}

BasketOrderNumber.propTypes = {
    orderNumber: PropTypes.string.isRequired,
}

export default BasketOrderNumber
